
































































import {Vue, Component, Prop} from "vue-property-decorator";
import RestcommNumbers from "@/consoleapi/api/restcomm/numbers";
import RestcommApplications from "@/consoleapi/api/restcomm/applications";

@Component
export default class ShowIncomingPhoneNumber extends Vue {
  @Prop() public sid!: string;

  private applications = {};

  private friendlyName = '';
  private phoneNumber = '';
  private voiceUrl = '';
  private voiceMethod = '';
  private statusCallBack = '';
  private statusCallBackMethod = '';
  private voiceFallBackUrl = '';
  private voiceFallBackMethod = '';
  private voiceApplicationSid = '';
  private voiceApplicationName = '';
  private voiceReferenceType = '';

  private deleteModal = false;

  findNumber() {
    const ipn = new RestcommNumbers();
    ipn.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
    ipn.find(this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)), this.sid)
        .then(response => {
          console.log(response.data);
          const number = response.data;
          this.friendlyName = number.friendly_name;
          this.phoneNumber = number.phone_number;
          this.voiceUrl = number.voice_url;
          this.voiceMethod = number.voice_method;
          this.statusCallBack = number.status_callback;
          this.statusCallBackMethod = number.status_callback_method;
          this.voiceFallBackUrl = number.voice_fallback_url;
          this.voiceFallBackMethod = number.voice_fallback_method;
          this.voiceApplicationSid = number.voice_application_sid;
          this.voiceApplicationName = number.voice_application_name;
          this.voiceReferenceType = this.voiceApplicationSid != null ? 'application' : 'url';
        })
        .catch(error => {
          console.log(error.response);
        });
  }

  getApplications() {
    const applications = new RestcommApplications();
    applications.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
    applications.get(this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)))
        .then(response => {
          console.log(response.data);
          this.applications = response.data;
        })
        .catch(error => {
          console.log(error.response);
        });
  }

  /**
   *
   */
  updateApplication() {
    const voiceUrl = this.voiceReferenceType === 'url' ? this.voiceUrl : '';
    const voiceApplicationSid = this.voiceReferenceType === 'application' ? this.voiceApplicationSid : '';
    const ipn = new RestcommNumbers();
    ipn.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
    ipn.update(this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)),
        this.sid,
        voiceUrl,
        this.voiceMethod,
        this.statusCallBack,
        this.statusCallBackMethod,
        this.voiceFallBackUrl,
        this.voiceFallBackMethod,
        voiceApplicationSid
    )
        .then(response => {
          console.log(response.data);
          this.findNumber();
        })
        .catch(error => {
          console.log(error.response);
        });
  }

  mounted() {
    this.findNumber();
    this.getApplications();
  }
}
